import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MetaManager = () => {
  const location = useLocation();

  useEffect(() => {
    const metaName = 'description';
    const content = 'Seetech is a trusted global supplier of high-quality spare parts for earth-moving equipment—including JCB, L&T, CAT & more—for construction, mining & infrastructure industries.';

    if (location.pathname === '/') {
      let metaDesc = document.querySelector(`meta[name="${metaName}"]`);
      if (metaDesc) {
        metaDesc.setAttribute('content', content);
        console.log("meta desc present")
      } else {
        metaDesc = document.createElement('meta');
        metaDesc.name = metaName;
        metaDesc.content = content;
        document.head.appendChild(metaDesc);
        console.log("meta desc added")
      }
    } else if (location.pathname === '/Shop' ||
          location.pathname === '/about' ||
          location.pathname === '/Blog' ||
          location.pathname === '/contact' 
    ) {
      const metaDesc = document.querySelector(`meta[name="${metaName}"]`);
      if (metaDesc) metaDesc.remove();
      console.log("meta desc removed")
    }
  }, [location]);

  return null;
};

export default MetaManager;
